import React, { useEffect, useState } from "react";
import { PlayCircle } from "lucide-react";
import { api } from "@/lib/api";
import { ShowCard } from "@/components/ShowCard";
import { Loading, PageHead, Empty } from "@/components/common";

export default function Replays() {
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/shows", { status: "ended" }).then((d) => setShows(d.shows)).catch(() => {}).finally(() => setLoading(false)); }, []);

  if (loading) return <Loading />;

  return (
    <div className="fade-up">
      <PageHead title="Replays" sub="Rewatch past shows and shop items that are still available." />
      {shows.length === 0 ? (
        <Empty icon={PlayCircle} title="No replays yet" sub="Ended shows will appear here to rewatch." />
      ) : (
        <div className="ss-grid grid-3" data-testid="replays-grid">
          {shows.map((s) => <ShowCard key={s.id} show={s} />)}
        </div>
      )}
    </div>
  );
}
